import { AfterViewInit, Component, ElementRef, forwardRef, Input, ViewChild } from '@angular/core';
import {FilterCompositeComponent} from '../filter-composite.component';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';


@Component({
  selector: 'app-text-search-composite',
  styleUrls: ['./text-search-composite.component.scss'],
  templateUrl: './text-search-composite.html',
  providers: [
    {
      provide: FilterCompositeComponent,
      useExisting: forwardRef(() => TextSearchCompositeComponent),
    },
  ],
  imports: [MatFormField, MatLabel, MatInput, MatIcon, MatIconButton, MatSuffix],
})
export class TextSearchCompositeComponent extends FilterCompositeComponent implements AfterViewInit {
  @Input() title: string;
  @Input() id: string;
  @ViewChild('searchInput')
  private input: ElementRef<HTMLInputElement>;

  hasValue = false;

  constructor() {
    super();
  }

  override label(): string {
    return this.title;
  }

  override criteria(): string {
    return this.input?.nativeElement?.value || null;
  }

  override clear() {
    if (this.input?.nativeElement?.value) {
      this.input.nativeElement.value = null;
    }
    this.hasValue = false;
  }

  onInput() {
    this.hasValue = !!this.input?.nativeElement?.value;
  }

  submit() {
    this.applied.emit();
  }

  onClearClick() {
    this.clear();
    this.applied.emit();
  }

  ngAfterViewInit(): void {}
}
